export async function handleFetchErrorResponse(message: string, res: Response) {
  if (!res.ok) {
    const error = new Error(message);
    // Attach extra info to the error object.
    try {
      // @ts-ignore
      error.info = await res.text();
    } catch (err) {}

    // @ts-ignore
    error.status = res.status;

    throw error;
  }
}

export function decodeJwt(token: string) {
  // 1. Split the token into its parts (Header, Payload, Signature)
  const parts = token.split('.');

  // Check if it looks like a JWT
  if (parts.length !== 3) {
    throw new Error('Invalid JWT format');
  }

  // 2. Select the Payload (the second part, index 1)
  const encodedPayload = parts[1];

  // 3. Decode the Base64url-encoded string
  // Base64url uses '-' instead of '+' and '_' instead of '/',
  // and omits padding ('=') compared to standard Base64.
  // The decodeBase64Url function handles this conversion.
  const base64 = encodedPayload.replace(/-/g, '+').replace(/_/g, '/');

  // Add padding if necessary for atob()
  const paddedBase64 = base64.padEnd(base64.length + ((4 - (base64.length % 4)) % 4), '=');

  // Use atob() to get the raw JSON string
  const jsonPayload = decodeURIComponent(
    atob(paddedBase64)
      .split('')
      .map(function (c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
      })
      .join(''),
  );

  // 4. Parse the JSON string into a JavaScript object
  return JSON.parse(jsonPayload);
}
